import { put, takeEvery, call } from "redux-saga/effects";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
// import "react-toastify/dist/ReactToastify.css";
// import { toast } from "react-toastify";

function* commonFunction(value) {
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: value.body ? value.body : null,
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: `${value.sucessAction}`,
        payload: resJSON,
      });
    }
  } catch (err) {
    console.error("error", err);
    if (err.ok === false) {
      yield put({ type: `${value.failAction}`, error: err });
    } else {
    }
  }
}

function* fetchShipperList(value) {
  try {
    let page = (value.payload && value.payload.page) || 1;
    let search = (value.payload && value.payload.search) || "";
    let searchFilterParam = "";
    if (search) {
      searchFilterParam = `&ser=${search}`;
    }
    let params = {
      page: page,

      api: `${appConfig.ip}/users?role=shipper-enterprise,shipper-individual&limit=10&page=${page}&ser=${search}`,
      method: "GET",
      sucessAction: actionTypes.FETCH_SHIPPERLIST_SUCCESS,
      failAction: actionTypes.FETCH_SHIPPERLIST_FAIL,
      body: null,
    };
    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

export function* shipperActionWatcher() {
  yield takeEvery(actionTypes.FETCH_SHIPPERLIST_INIT, fetchShipperList);
}
